module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="course" style="border-right:none">\n    <div class="left_course" style="border-left:4px solid #72685d">\n        <span class="studioname">Plus de cours aujourd\'hui</span>\n        <span class="activityname">A demain</span>\n    </div>\n    <div class="bottom_course">\n        <p class="course_desc">Revenez demain pour une nouvelle journée pleine d\'activités !</p>\n        <div class="image_activity" style="background-image: url(img/logo-resamania-inline.png)">\n        </div>\n    </div>\n</div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="course" style="border-right:none">\n    <div class="left_course" style="border-left:4px solid #72685d">\n        <span class="studioname">Plus de cours aujourd\'hui</span>\n        <span class="activityname">A demain</span>\n    </div>\n    <div class="bottom_course">\n        <p class="course_desc">Revenez demain pour une nouvelle journée pleine d\'activités !</p>\n        <div class="image_activity" style="background-image: url(img/logo-resamania-inline.png)">\n        </div>\n    </div>\n</div>\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1731405454-2.1.11/node_modules/ejs-compiled-loader!./src/templates/popup_footer_activities_empty.ejs
// module id = 142
// module chunks = 0